import { ListTodo, Plus } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Section } from '@/components/common/Blocks'
import { Button } from '@/components/ui/button'
import { useFollowups } from '../../api'
import type { CrmDialog } from '../CrmDialogs'
import { FollowupList } from '../SalesLists'
import { useCrmDeletes } from '../useCrmDeletes'

/** Müşterinin takip görevleri; tamamlananlar istenirse gösterilir. */
export function FollowupsCard({ customerId, canWrite, open }: { customerId: string; canWrite: boolean; open: (d: CrmDialog) => void }) {
  const { t } = useTranslation()
  const deletes = useCrmDeletes()
  const [showDone, setShowDone] = useState(false)
  const all = (useFollowups().data ?? []).filter((f) => f.customerId === customerId)
  const done = all.filter((f) => f.done).length
  const rows = showDone ? all : all.filter((f) => !f.done)

  return (
    <Section
      title={t('crm.followup.title')}
      icon={ListTodo}
      bodyClassName="p-0"
      actions={
        canWrite ? (
          <Button size="sm" variant="outline" onClick={() => open({ kind: 'followup', followup: null })}>
            <Plus />
            {t('crm.followup.add')}
          </Button>
        ) : null
      }
    >
      <FollowupList rows={rows} canWrite={canWrite} onEdit={(f) => open({ kind: 'followup', followup: f })} onDelete={(f) => void deletes.followup(f)} />
      {done ? (
        <button type="button" onClick={() => setShowDone((v) => !v)} className="w-full border-t px-4 py-2 text-left text-xs font-medium text-primary hover:bg-muted/40">
          {t(showDone ? 'crm.followup.hideDone' : 'crm.followup.showDone', { count: done })}
        </button>
      ) : null}
    </Section>
  )
}
